import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Tooltip,
} from '@material-ui/core';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Visibility, GetApp } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import ViewReportModal from './ViewReportModal';
import moment from 'moment';
import styles from './styles';
import Header from './Header';
import RestaurantSelectionModal from '../../components/OperationHoursTab/RestaurantDetails/RestaurantSelectionModal';
import AppConstants from '../../AppConstants';
import { paginationCountLabel, propertyToggle } from '../../utils/helpers';
import {
  getUploadHistory,
  setPageAction,
  setRowsPerPageAction,
  downloadExcel,
} from '../../redux/actions/uploadHistoryActions';
import RBISelectButton from '../../components/RBISelectButton/RBISelectButton';
import RBICalenderSearch from '../../components/RBICalenderSearch/RBICalenderSearch';
import { formatYYYYMMDD } from '../../utils/utils';
import { setSelectedRestaurantList as setSelectedRestaurants } from '../../redux/actions/restaurantsActions';
import RBISearchButton from '../../components/RBISearchButton/RBISearchButton';
import omit from 'lodash/omit';

export default function MassUploadsHistory() {
  const classes = styles();
  const [openRestaurantModal, setOpenRestaurantModal] = useState(false);
  const [viewReportModal, setViewReportModalModal] = useState({
    open: false,
    reportData: {},
  });
  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  const { userInfo } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );

  const [selectedRestaurantsNumber, setRestaurantNumber] = useState('');

  const { t } = useTranslation();
  const dispatch: any = useDispatch();

  const paginationConfig = useSelector(
    (state: RootStateOrAny) => state?.UploadHistoryReducer?.paginationConfig,
  );
  const rows = useSelector(
    (state: RootStateOrAny) => state?.UploadHistoryReducer?.history,
  );
  let currentUserInfo = t('massUpload.viewHistory.Self');
  if (userInfo.data) {
    currentUserInfo =
      userInfo?.data?.payload?.profile?.firstName +
      ' ' +
      userInfo?.data?.payload?.profile?.lastName;
  } else if (userInfo.family_name && userInfo.given_name) {
    currentUserInfo = userInfo.family_name + ' ' + userInfo.given_name;
  } else {
    currentUserInfo = userInfo.name;
  }

  const [initialHistory, setHistory] = useState<any>({
    referenceId: '',
    uploadType: '',
    user: '',
    startDate: moment().subtract(14, 'days'),
    endDate: moment(),
    restaurants: [],
  });

  const handleChange = (
    event: React.ChangeEvent<{ value: unknown; name?: any }>,
  ) => {
    setHistory({
      ...initialHistory,
      [event.target.name]: event.target.value,
    });
  };

  const updateTypeOptions = [
    { name: t('massUpload.viewHistory.all'), value: 'all' },
    { name: t('massUpload.updateType.excel'), value: 'mass_upload' },
    { name: t('massUpload.updateType.manual'), value: 'mass_update' },
  ];

  const statusOption = [
    { name: t('massUpload.status.completed'), value: 1 },
    { name: t('massUpload.status.inProgress'), value: 0 },
  ];

  const updatedByOptions = [
    { name: t('massUpload.viewHistory.all'), value: 'all' },
    { name: currentUserInfo, value: 'self' },
  ];

  const modifysearchHistory = () => {
    const startDate =
      moment(initialHistory['startDate']).format(formatYYYYMMDD) + ' 00:00:00';
    const endDate =
      moment(initialHistory['endDate']).format(formatYYYYMMDD) + ' 23:59:00';
    const restaurants = JSON.stringify(initialHistory['restaurants']);
    const user = initialHistory.user === 'self' ? '' : initialHistory.user;
    const uuid = initialHistory['referenceId'];
    return {
      ...omit(initialHistory, 'referenceId'),
      startDate,
      endDate,
      restaurants,
      user,
      uuid,
    };
  };

  useEffect(() => {
    if (thisUser.hasViewMenuItemOperationHours) {
      dispatch(setRowsPerPageAction(AppConstants.rowsPerPage));
      dispatch(
        getUploadHistory({
          ...modifysearchHistory(),
          PAGE: 1,
          LIMIT: AppConstants.rowsPerPage,
        }),
      );
      dispatch(setPageAction(1));
    }
    return () => {
      dispatch(setSelectedRestaurants([]));
    };
  }, [thisUser.hasViewMenuItemOperationHours]);

  const handleApplyButton = (name: string | undefined, value: any) => {
    setHistory({
      ...initialHistory,
      [name as string]: propertyToggle(value, value, ''),
    });
    paginationConfig.page = 1;
    dispatch(
      getUploadHistory({
        ...modifysearchHistory(),
        PAGE: 1,
        LIMIT: paginationConfig.rowsPerPage,
      }),
    );
  };

  const handlePress = row => {
    dispatch(downloadExcel({ downloadType: 'excel', filename: row.filename }));
  };

  const handleViewReportPress = (row = {}) => {
    setViewReportModalModal({ open: !viewReportModal.open, reportData: row });
  };

  const tableViewReport = row => (
    <Tooltip title={t('massUpload.history.viewReport') || ''}>
      <IconButton disabled={!row.email_status}>
        <Visibility
          onClick={() => handleViewReportPress(row)}
          style={{ cursor: 'pointer' }}
        />
      </IconButton>
    </Tooltip>
  );

  const tableDescriptionMessage = (row, option, key) => {
    if (!row[key] || row[key].includes('null')) return '-';
    const statusDesc = row[key]
      .split(',')
      .map(message => {
        return message && t(`massUpload.history.${message}`);
      })
      .filter(message => message && !message.includes('null'))
      .join(',');
    return (
      <Tooltip title={statusDesc}>
        <div
          style={
            statusDesc.length > 20 ? { width: '40ch' } : { width: '140px' }
          }
          className={classes.cellWrapper}
        >
          {statusDesc}
        </div>
      </Tooltip>
    );
  };

  const tableDownloadReport = row => (
    <Tooltip title={t('massUpload.history.downloadSheet') || ''}>
      <IconButton
        disabled={!row.email_status || row.upload_type === 'mass_update'}
      >
        <GetApp
          onClick={() => handlePress(row)}
          style={{ cursor: 'pointer' }}
        />
      </IconButton>
    </Tooltip>
  );

  const tableOptions = (row, tableOtion, key) => {
    const optionName = tableOtion.find(c => c.value === row[key])?.name;
    return optionName;
  };
  interface Column {
    id:
      | 'createdAt'
      | 'uuid'
      | 'viewReport'
      | 'username'
      | 'email_status'
      | 'upload_type'
      | 'status_description';
    label: string | any;
    minWidth?: number;
    maxWidth?: number;
    paddingTop?: number;
    paddingBottom?: number;
    paddingLeft?: number;
    paddingRight?: number;
    textAlign?: string | any;
    padding?: number;
    isFilterAvailable?: boolean;
    format?: boolean | any;
    actions?: [any];
    options?: any;
  }

  const columns: Column[] = [
    {
      minWidth: 215,
      maxWidth: 250,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 1,
      label: (
        <div className={classes.dropDownSelector}>
          <RBICalenderSearch
            id={'date'}
            onChangeInput={(startDate, endDate) => {
              setHistory({
                ...initialHistory,
                startDate,
                endDate,
              });
            }}
            selectedStartDate={initialHistory['startDate']}
            selectedEndDate={initialHistory['endDate']}
            handleApplyButton={handleApplyButton}
          />
        </div>
      ),
      id: 'createdAt',
      isFilterAvailable: true,
      format: true,
    },
    {
      minWidth: 120,
      maxWidth: 250,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 1,
      label: (
        <div className={classes.dropDownSelector}>
          <RBISelectButton
            id={'user'}
            valueOption={initialHistory['user']}
            labelText={
              initialHistory['user']
                ? updatedByOptions.find(u => u.value === initialHistory['user'])
                    ?.name || t('massUpload.header.updatedBy')
                : t('massUpload.header.updatedBy')
            }
            width={140}
            onChangeInput={handleChange}
            options={updatedByOptions.map(status => ({
              ...status,
              name: status.name,
            }))}
            handleApplyButton={handleApplyButton}
            ellipsisLabelText={true}
          />
        </div>
      ),
      id: 'username',
      isFilterAvailable: true,
    },
    {
      minWidth: 165,
      maxWidth: 250,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 1,
      label: (
        <div className={classes.dropDownSelector}>
          <RBISelectButton
            id={'uploadType'}
            valueOption={initialHistory['uploadType']}
            labelText={
              initialHistory['uploadType']
                ? updateTypeOptions.find(
                    u => u.value === initialHistory['uploadType'],
                  )?.name || t('massUpload.header.updatedType')
                : t('massUpload.header.updatedType')
            }
            width={140}
            onChangeInput={handleChange}
            options={updateTypeOptions.map(status => ({
              ...status,
              name: status.name,
            }))}
            handleApplyButton={handleApplyButton}
            ellipsisLabelText={true}
          />
        </div>
      ),
      id: 'upload_type',
      isFilterAvailable: true,
      actions: [tableOptions],
      options: updateTypeOptions,
    },
    {
      minWidth: 100,
      maxWidth: 120,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 1,
      label: t('massUpload.history.status'),
      id: 'email_status',
      actions: [tableOptions],
      options: statusOption,
    },
    {
      minWidth: 140,
      maxWidth: 159,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 1,
      label: t('massUpload.history.description'),
      actions: [tableDescriptionMessage],
      id: 'status_description',
    },
    {
      minWidth: 100,
      maxWidth: 120,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 1,
      label: t('operationHours.download'),
      id: 'uuid',
      actions: [tableDownloadReport],
    },
    {
      minWidth: 100,
      maxWidth: 120,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 1,
      label: t('massUpload.history.viewReport'),
      id: 'viewReport',
      actions: [tableViewReport],
    },
  ];

  const handleSelectedRestaurantsModal = () => {
    setOpenRestaurantModal(!openRestaurantModal);
  };

  const updateRestaurantNumbers = selectedRestaurants => {
    const restaurantId = selectedRestaurants.map(
      restaurant => restaurant.metas?.restaurantId,
    );
    const restaurantNumbers = selectedRestaurants.map(
      restaurant => restaurant?.number,
    );
    setHistory({
      ...initialHistory,
      restaurants: restaurantId,
    });
    setRestaurantNumber(restaurantNumbers.join());
    dispatch(
      getUploadHistory({
        ...modifysearchHistory(),
        restaurants: JSON.stringify(restaurantId),
        PAGE: 1,
        LIMIT: paginationConfig.rowsPerPage,
      }),
    );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(setRowsPerPageAction(+event.target.value));
    dispatch(setPageAction(1));
    dispatch(
      getUploadHistory({
        ...modifysearchHistory(),
        PAGE: 1,
        LIMIT: +event.target.value,
      }),
    );
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    dispatch(setPageAction(newPage + 1));
    dispatch(
      getUploadHistory({
        ...modifysearchHistory(),
        PAGE: newPage + 1,
        LIMIT: paginationConfig.rowsPerPage,
      }),
    );
  };

  return thisUser.hasViewMenuItemOperationHours ? (
    <Paper className={classes.paperStyle}>
      <Header headerText={t('massUpload.history.uploadHistory')} />
      <Box marginTop={1} display="flex">
        <Grid
          container
          spacing={0}
          justifyContent="space-between"
          alignItems="center"
        >
          <RBISearchButton
            id={'referenceId'}
            freeSolo={true}
            valueOption={initialHistory['referenceId']}
            labelText={t('massUpload.history.referenceId')}
            noOptions={true}
            onChange={handleChange}
            handleApplyButton={handleApplyButton}
            width={200}
          />
        </Grid>

        <Grid
          container
          spacing={0}
          justifyContent="space-between"
          alignItems="center"
          className={classes.searchBar}
        >
          <Tooltip title={selectedRestaurantsNumber || ''}>
            <Button
              variant="outlined"
              classes={{
                label: classes.availabilityFilterLabel,
                root: classes.availabilityButton,
              }}
              onClick={handleSelectedRestaurantsModal}
            >
              {selectedRestaurantsNumber
                ? selectedRestaurantsNumber
                : t('massUpload.header.filterRestaurants')}
            </Button>
          </Tooltip>
        </Grid>
      </Box>
      <Box marginTop={1}>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={`column-${index}`}
                    style={{
                      minWidth: column.minWidth,
                      maxWidth: column.maxWidth,
                      paddingTop: column.paddingTop,
                      paddingBottom: column.paddingBottom,
                      paddingLeft: column.paddingLeft,
                      paddingRight: column.paddingRight,
                      fontSize: 16,
                    }}
                  >
                    <Box
                      paddingY={1}
                      display="flex"
                      justifyContent="center"
                      alignContent="center"
                    >
                      <b>{column.label}</b>
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length ? (
                rows.map(row => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column: Column) => {
                        if (column.actions) {
                          return (
                            <TableCell key={column.id}>
                              {column.actions[0](
                                row,
                                column.options && column.options,
                                column.id,
                              )}
                            </TableCell>
                          );
                        }

                        const value = row[column.id];
                        return (
                          <TableCell key={column.id}>
                            {column.format
                              ? moment(value).format(
                                  `${formatYYYYMMDD}, h:mm a`,
                                )
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={42}>
                    <div style={{ textAlign: 'center' }}>
                      <Typography>
                        {t('massUpload.history.noHistory')}
                      </Typography>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={AppConstants.rowsPerPageOptions}
          count={paginationConfig.total}
          rowsPerPage={paginationConfig.rowsPerPage}
          page={paginationConfig.page - 1}
          component={'div'}
          onPageChange={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={t('app.common.rowsPerPage')}
          labelDisplayedRows={({ from, to, count }) =>
            paginationCountLabel(
              from,
              to,
              count,
              t('app.common.paginationCountLabel'),
            )
          }
        />
      </Box>
      {openRestaurantModal && (
        <RestaurantSelectionModal
          openRestaurantModal={openRestaurantModal}
          handleSelectedRestaurantsModal={handleSelectedRestaurantsModal}
          textValue="Filter"
          actionOnSave={updateRestaurantNumbers}
          disabled={false}
        />
      )}
      {viewReportModal.open && (
        <ViewReportModal
          isOpen={viewReportModal.open}
          onClose={handleViewReportPress}
          reportData={viewReportModal.reportData}
        />
      )}
    </Paper>
  ) : (
    <Redirect to={`/operations`} />
  );
}
